import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import AirHandlingUnitDetail from '../../components/ac_central/AirHandlingUnitDetail';
import { defaultRejectHandler, toCoolingCap } from '../../utils/utility';
import {
  getAirHandlingUnit,
  editAirHandlingUnit,
} from '../../redux/ac_central/air_handling_unit_actions';

class AirHandlingUnitEditModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };

    this.ahuDetail = undefined;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.ahu !== nextProps.ahu && nextProps.show) {
      this.props.getAirHandlingUnit(nextProps.ahu.id);
    }
  }

  onSaveHandler() {
    const editedAHU = this.ahuDetail.getWrappedInstance().getWrappedInstance().getAHUData();
    this.props.editAirHandlingUnit({
      ...editedAHU,
      id: this.props.ahu.id,
    });
  }

  render() {
    const { isEditing, errorMessage, ahuDetail, t, getAirHandlingUnit, editAirHandlingUnit, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('edit air handling unit')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AirHandlingUnitDetail
            ahu={ahuDetail}
            ref={ref => (this.ahuDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isEditing && !this.props.isEdited && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="air-conditioning-air-handling-unit-submit-edit"
            disabled={!isSubmittable || isEditing}
            onClick={() => this.onSaveHandler()}
          >
            {isEditing ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, props) => ({
  errorMessage: state.ac.airHandlingUnit.errorMessage,
  isEditing: state.ac.airHandlingUnit.isEditing,
  ahuDetail: props.ahu && state.ac.airHandlingUnit.objects[props.ahu.id],
});

const mapDispatchToProps = dispatch => ({
  editAirHandlingUnit: ahu =>
    defaultRejectHandler(
      dispatch(
        editAirHandlingUnit(
          ahu.id,
          ahu.name,
          ahu.type,
          toCoolingCap(ahu.cooling_capacity, ahu.unit),
          ahu.unit,
          ahu.power_required,
          ahu.description,
          ahu.image,
        ),
      ),
    ),
  getAirHandlingUnit: id =>
    defaultRejectHandler(dispatch(getAirHandlingUnit(id))),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(AirHandlingUnitEditModal),
);



// WEBPACK FOOTER //
// ./src/modal/ac_central/AirHandlingUnitEditModal.js